// Works out the estimated delivery dates in the visitor's browser from today's date in the store's
// time zone, so the dates stay correct even if the page HTML was cached. The server-rendered dates
// are the fallback if this does not run.
// Day-first dates (21 Oct) for English, as is usual in the UAE.
const lang = document.documentElement.lang || 'en';
const locale = lang.startsWith('en') ? 'en-GB' : lang;

function dubaiToday(timeZone) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' })
    .formatToParts(new Date())
    .reduce((acc, part) => ({ ...acc, [part.type]: Number(part.value) }), {});
  return Date.UTC(parts.year, parts.month - 1, parts.day);
}

function render(card) {
  const timeZone = card.dataset.timezone || 'Asia/Dubai';
  const min = Number(card.dataset.minDays);
  const max = Number(card.dataset.maxDays);
  const skip = (card.dataset.skipDays || '').split(',').map((d) => d.trim().toLowerCase()).filter(Boolean);
  const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'UTC' });
  const weekday = new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' });
  const dayMonth = new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short', timeZone: 'UTC' });

  const today = dubaiToday(timeZone);
  let counted = 0;
  let start = null;
  let end = null;
  for (let offset = 1; offset <= 30 && end === null; offset += 1) {
    const candidate = today + offset * 86400000;
    if (skip.includes(dayName.format(candidate).toLowerCase())) continue;
    counted += 1;
    if (counted === min && start === null) start = candidate;
    if (counted === max) end = candidate;
  }
  if (start === null || end === null) return;

  const fill = (el, ms) => {
    if (el) el.innerHTML = `<b>${weekday.format(ms)}</b> ${dayMonth.format(ms)}`;
  };
  fill(card.querySelector('[data-delivery-date="start"]'), start);
  fill(card.querySelector('[data-delivery-date="end"]'), end);
}

document.querySelectorAll('[data-delivery-card]').forEach(render);
